import { ProductOriginal } from "app/pages/Listing/Product/ProductOriginal";
import ProductCard from "app/pages/.shared/ProductCard/ProductCard";
import { useFsFlag } from "@flagship.io/react-sdk";

export default props => {
	const productCardDesignFlag = useFsFlag("product-card-design", "");
	const productCardDesignValue = productCardDesignFlag.getValue();

	switch (productCardDesignValue) {
		case "new-price-left":
		case "new-price-right":
			return (
				<ProductCard
					{...props}
					isPriceRight={productCardDesignValue === "new-price-right"}
				/>
			);
		default:
			return <ProductOriginal {...props} />;
	}
};
